// extracted by mini-css-extract-plugin
module.exports = {"container":"client-module--container--5o9EG","img":"client-module--img--3NIyV"};